import { render, staticRenderFns } from "./PublicSetting.vue?vue&type=template&id=2251a4f9&scoped=true&"
import script from "./PublicSetting.vue?vue&type=script&lang=js&"
export * from "./PublicSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251a4f9",
  null
  
)

export default component.exports